import { Typography } from 'antd';
import { theme } from 'configs/styled';
import React, { forwardRef } from 'react';
import { StyledLabel } from './Label.style';
import { ILabelProps } from './Label.type';

const Label = forwardRef<HTMLDivElement, ILabelProps>(function Label(
  {
    fontSize = 'normal',
    color = theme.palettes.blackTextBold,
    bold = false,
    text = '',
    ...props
  },
  ref,
) {
  return (
    <StyledLabel color={color} ref={ref} {...props} className={props.className}>
      <Typography.Text className={fontSize} strong={bold}>
        {text}
      </Typography.Text>
    </StyledLabel>
  );
});

export default Label;
